import { Component, OnInit } from '@angular/core';
import { ParentFormGroup } from 'app/tools/parent-formgroup';

@Component({
  selector: 'text-celular',
  templateUrl: './text-celular.component.html',
  styleUrls: ['./text-celular.component.scss'],
  viewProviders: [ParentFormGroup],
})
export class TextCelularComponent implements OnInit {
  
  constructor() {}

  ngOnInit() { }

}
